export default __webpack_public_path__ + "static/media/hanging-plant.a43eb403.png";